export const activitiesPath = () => '/settings/activities';
export const activitiesExtensionsPath = () => `${activitiesPath()}/extensions`;
export const activitiesRulesPath = () => `${activitiesPath()}/rules`;
